<template>
  <div class="wheel-battle-stats-entry">
    <div class="selector-card">
      <div class="selector-row">
        <span class="selector-label">球队</span>
        <div class="team-options">
          <div
            v-for="team in teams"
            :key="team.id"
            class="team-option"
            @click="selectTeam(team)"
          >
            <div
              class="team-option-logo-wrap"
              :class="{ 'is-selected': selectedTeamId === team.id }"
            >
              <img
                v-if="getTeamLogoUrl(team)"
                class="team-option-logo"
                :src="getTeamLogoUrl(team)"
                alt=""
              />
              <div v-else class="team-option-logo team-option-logo-placeholder" />
              <van-icon
                v-if="selectedTeamId === team.id"
                name="success"
                class="team-check"
                color="#fff"
                size="16"
              />
            </div>
            <span class="team-option-name">{{ team.name }}</span>
          </div>
        </div>
      </div>
      <div class="selector-divider" />
      <div class="selector-row selector-row-player" @click="openPlayerPicker">
        <span class="selector-label">球员</span>
        <div class="player-value">
          <span :class="{ 'player-placeholder': !selectedPlayer.id }">
            {{ playerDisplayName }}
          </span>
          <van-icon name="arrow" color="#c8c8c8" size="14" />
        </div>
      </div>
    </div>

    <div class="stats-form">
      <div
        v-for="item in statFields"
        :key="item.key"
        class="stat-row"
      >
        <span class="stat-label">{{ item.label }}</span>
        <van-stepper
          v-model="form[item.key]"
          integer
          min="0"
          disable-input
        />
      </div>
    </div>

    <div class="footer">
      <div class="footer-inner">
        <van-button
          type="primary"
          round
          class="submit-btn"
          :loading="submitting"
          @click="onSubmit"
        >
          提交
        </van-button>
      </div>
      <div class="footer-safe-area" />
    </div>

    <van-popup v-model="showPlayerPicker" position="bottom" round>
      <van-picker
        show-toolbar
        title="选择球员"
        value-key="label"
        :columns="playerPickerColumns"
        @confirm="onPlayerConfirm"
        @cancel="showPlayerPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon, Button, Stepper, Toast, Popup, Picker } from 'vant'
Vue.use(Icon).use(Button).use(Stepper).use(Toast).use(Popup).use(Picker)

import { adminGetBMMatchWheelBattleChildGame } from '@/api/wheel-battle'
import { scoreEntryStateFromChildGameDetail } from '@/api/wheel-battle/adapter'
import {
  adminGetBMBktGameEventPlayerList,
  bMMatchOrganizationUpdateBMGameEvents as updateFootballGameEvents
} from '@/api/match'
import { buildUpdateFootballGameEventsParams } from './utils/api-params'
import { resolveTeamLogoUrl } from './utils/team-logo'

function createEmptyPlayerStatsForm() {
  return {
    goalCount: 0,
    assistCount: 0,
    yellowCardCount: 0,
    redCardCount: 0,
    ownGoalCount: 0
  }
}

function mapGameEventPlayer(player) {
  if (!player) {
    return null
  }
  return {
    id: String(player.id),
    name: player.trueName || player.name || '',
    num: player.number || '',
    goalCount: player.goalEventCount != null
      ? player.goalEventCount
      : (player.goalCount || 0),
    assistCount: player.assistEventCount != null
      ? player.assistEventCount
      : (player.assistCount || 0),
    yellowCardCount: player.yellowCardEventCount != null
      ? player.yellowCardEventCount
      : (player.yellowCardCount || 0),
    redCardCount: player.redCardEventCount != null
      ? player.redCardEventCount
      : (player.redCardCount || 0),
    ownGoalCount: player.ownGoalEventCount != null
      ? player.ownGoalEventCount
      : (player.ownGoalCount || 0)
  }
}

export default {
  name: 'WheelBattleStatsEntry',
  data: function () {
    return {
      parentGameId: '',
      subMatchId: '',
      unionMatchId: '',
      matchId: '',
      matchLogo: '',
      statId: '',
      subMatch: {
        homeTeam: {},
        awayTeam: {}
      },
      teams: [],
      selectedTeamId: '',
      selectedPlayer: {},
      players: [],
      form: createEmptyPlayerStatsForm(),
      showPlayerPicker: false,
      submitting: false,
      statFields: [
        { key: 'goalCount', label: '进球数' },
        { key: 'assistCount', label: '助攻数' },
        { key: 'yellowCardCount', label: '黄牌数' },
        { key: 'redCardCount', label: '红牌数' },
        { key: 'ownGoalCount', label: '乌龙球' }
      ]
    }
  },
  computed: {
    playerDisplayName: function () {
      if (!this.selectedPlayer.id) {
        return ''
      }
      var num = this.selectedPlayer.num ? this.selectedPlayer.num + ' ' : ''
      return num + this.selectedPlayer.name
    },
    playerPickerColumns: function () {
      return (this.players || []).map(function (player) {
        var num = player.num ? player.num + ' ' : ''
        return Object.assign({}, player, {
          label: num + player.name
        })
      })
    }
  },
  mounted: function () {
    this.parentGameId = this.$route.params.parentGameId || ''
    this.subMatchId = this.$route.params.subMatchId || ''
    this.unionMatchId = this.$route.query.unionMatchId || ''
    this.statId = this.$route.query.statId || ''
    this.loadSubMatch()
  },
  methods: {
    getTeamLogoUrl: function (team) {
      return resolveTeamLogoUrl(team, this.matchLogo, 60, 60)
    },
    syncFormFromPlayer: function (player) {
      if (!player || !player.id) {
        this.form = createEmptyPlayerStatsForm()
        return
      }
      this.form = {
        goalCount: player.goalCount || 0,
        assistCount: player.assistCount || 0,
        yellowCardCount: player.yellowCardCount || 0,
        redCardCount: player.redCardCount || 0,
        ownGoalCount: player.ownGoalCount || 0
      }
    },
    loadSubMatch: function () {
      var self = this
      adminGetBMMatchWheelBattleChildGame({
        gameId: this.subMatchId
      }).then(function (res) {
        if (res && res.error) {
          Toast((res.messages && res.messages[0]) || '加载失败')
          return
        }
        var page = scoreEntryStateFromChildGameDetail(res && res.data)
        if (!page || !page.subMatch) {
          Toast('比赛不存在')
          return
        }
        var apiDetail = res.data || {}
        var childGame = apiDetail.childGame || {}
        var parentGame = apiDetail.parentGame || {}
        self.subMatch = page.subMatch
        self.matchId = String(
          childGame.matchId || parentGame.matchId || ''
        )
        self.matchLogo = page.unionMatchIcon || ''
        self.teams = [self.subMatch.homeTeam, self.subMatch.awayTeam].filter(function (team) {
          return team && team.id
        })
        if (self.statId) {
          self.loadStatDetail()
        } else if (self.teams.length) {
          self.selectTeam(self.teams[0])
        }
      }).catch(function () {
        Toast('加载失败，请稍后重试')
      })
    },
    loadStatDetail: function () {
      var self = this
      var playerId = String(this.statId)
      var pendingTeams = this.teams.slice()

      function tryLoadNextTeam() {
        if (!pendingTeams.length) {
          return
        }
        var team = pendingTeams.shift()
        self.loadPlayers(team.id, function () {
          for (var i = 0; i < self.players.length; i++) {
            if (self.players[i].id === playerId) {
              self.selectedTeamId = team.id
              self.selectedPlayer = Object.assign({}, self.players[i])
              self.syncFormFromPlayer(self.players[i])
              return
            }
          }
          tryLoadNextTeam()
        })
      }

      tryLoadNextTeam()
    },
    selectTeam: function (team) {
      if (!team || !team.id) {
        return
      }
      this.selectedTeamId = team.id
      this.selectedPlayer = {}
      this.form = createEmptyPlayerStatsForm()
      this.loadPlayers(team.id)
    },
    loadPlayers: function (teamId, callback) {
      var self = this
      if (!this.matchId || !teamId || !this.subMatchId) {
        self.players = []
        if (typeof callback === 'function') {
          callback()
        }
        return
      }
      adminGetBMBktGameEventPlayerList({
        matchId: this.matchId,
        teamId: teamId,
        gameId: this.subMatchId
      }).then(function (res) {
        var playerList = (res && res.data && res.data.playerList) || []
        self.players = playerList.map(mapGameEventPlayer).filter(function (player) {
          return player && player.id
        })
        if (typeof callback === 'function') {
          callback()
        }
      }).catch(function () {
        self.players = []
        if (typeof callback === 'function') {
          callback()
        }
      })
    },
    openPlayerPicker: function () {
      if (!this.selectedTeamId) {
        Toast('请先选择球队')
        return
      }
      if (!this.players.length) {
        Toast('暂无球员数据')
        return
      }
      this.showPlayerPicker = true
    },
    onPlayerConfirm: function (player) {
      this.showPlayerPicker = false
      if (!player) {
        return
      }
      this.selectedPlayer = Object.assign({}, player)
      this.syncFormFromPlayer(player)
    },
    submitGameEvent: function (form, callback) {
      return updateFootballGameEvents(
        buildUpdateFootballGameEventsParams({
          playerId: this.selectedPlayer.id,
          teamId: this.selectedTeamId,
          gameId: this.subMatchId,
          form: form || this.form
        })
      ).then(function (res) {
        if (res && res.error) {
          throw new Error((res.messages && res.messages[0]) || '提交失败')
        }
        if (typeof callback === 'function') {
          callback(res)
        }
        return res
      }).catch(function (err) {
        Toast((err && err.message) || '提交失败，请稍后重试')
        throw err
      })
    },
    onSubmit: function () {
      var self = this
      if (!this.selectedTeamId) {
        Toast('请选择球队')
        return
      }
      if (!this.selectedPlayer.id) {
        Toast('请选择球员')
        return
      }
      this.submitting = true
      this.submitGameEvent(this.form).then(function () {
        self.submitting = false
        Toast.success('提交成功')
        self.$router.back()
      }).catch(function () {
        self.submitting = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-stats-entry {
  padding-top: 12px;
  min-height: 100vh;
  background: #f1f1f1;
  padding-bottom: calc(64px + constant(safe-area-inset-bottom));
  padding-bottom: calc(64px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.selector-card {
  margin: 12px;
  margin-top: 0;
  background: #fff;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  overflow: hidden;
}

.selector-row {
  display: flex;
  align-items: center;
  min-height: 56px;
  padding: 12px 16px;
  box-sizing: border-box;
}

.selector-label {
  flex-shrink: 0;
  width: 48px;
  font-size: 14px;
  color: #999999;
}

.team-options {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.team-option:not(:last-child) {
  margin-right: 24px;
}

.team-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
}

.team-option-logo-wrap {
  position: relative;
  width: 60px;
  height: 60px;

  &.is-selected::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.5);
  }
}

.team-option-logo {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  object-fit: cover;
}

.team-option-logo-placeholder {
  background: #e5e5e5;
}

.team-check {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #17ae5f;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.team-option-name {
  margin-top: 6px;
  font-size: 12px;
  color: #1d2129;
  line-height: 1.2;
  text-align: center;
}

.selector-divider {
  height: 1px;
  margin: 0 16px;
  background: #f0f0f0;
}

.selector-row-player {
  cursor: pointer;
}

.player-value {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  color: #1d2129;

  span {
    margin-right: 4px;
  }
}

.player-placeholder {
  color: #c8c8c8;
}

.stats-form {
  background: #fff;
}

.stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  padding: 0 16px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.stat-label {
  font-size: 14px;
  color: #1d2129;
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: #fff;
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.06);
}

.footer-inner {
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.footer-safe-area {
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
}

.submit-btn {
  min-width: 120px;
  height: 40px;
  background: #337ecc;
  border-color: #337ecc;
}
</style>
